import type { Value } from 'platejs';

// Walks the Plate value tree and collects userIds from every `mention`
// inline node. The shape accepted is permissive:
//   - new mentions (created by @platejs/mention): { type: 'mention', key, value }
//   - legacy slate→plate-migrated mentions: { type: 'mention', userId, value }
// Order is depth-first (document order); duplicates are removed but the
// first-seen index wins, so the returned list is stable.
export function getMentionedUserIds(value: Value | undefined): string[] {
    const seen = new Set<string>();
    const ordered: string[] = [];

    const visit = (n: any) => {
        if (!n || typeof n !== 'object') return;
        if (n.type === 'mention') {
            const id = (n.userId as string) ?? (n.key as string) ?? '';
            if (id && !seen.has(id)) {
                seen.add(id);
                ordered.push(id);
            }
        }
        if (Array.isArray(n.children)) {
            for (const c of n.children) visit(c);
        }
    };

    if (Array.isArray(value)) {
        for (const block of value) visit(block);
    }

    return ordered;
}
